<template>
  <div class="view-group">
    <div v-if="data.tableBomData.length && index !== len - 1" class="view-line-l"></div>
    <div class="view-box">
      <div class="view-item">
        <div class="view-toggle">
          <span
            v-if="data.tableBomData.length"
            :title="selfShowBom ? '收起' : '展开'"
            :class="['toggle-icon', 'iconfont', selfShowBom ? 'icon-jian' : 'icon-jia']"
            @click="groupToggle"
          ></span>
          <span v-else class="default-icon"></span>
          <span class="view-arrow">&gt;</span>
          <span class="view-line-x"></span>
          <span v-if="!isSource" class="view-line-y"></span>
        </div>
        <div class="view-content">
          <div class="flex">
            <e-upload-image :list="data.list_chan_pin_tu" size="58px" disabled />
            <div class="view-info">
              <div class="f-s-14 f-bold">
                <span v-if="data.name">{{ data.name }}</span>
                <span v-if="data.spec">({{ data.spec }})</span>
              </div>
              <div class="m-t-5 c-gray-light">
                <span>{{ data.counts }}{{ data.unit }}</span>
                <span class="m-l-10">¥{{ data.goods_price }}/{{ data.unit }}</span>
              </div>
              <div class="m-t-5 c-red f-bold f-s-14">¥{{ data.goods_amount }}</div>
            </div>
          </div>
          <ViewStep :data="data" />
        </div>
      </div>
    </div>
    <template v-if="selfShowBom">
      <ViewItem
        v-for="(item, index) in data.tableBomData"
        :key="index"
        :index="index"
        :len="data.tableBomData.length"
        :isSource="false"
        :isShowBom="isShowBom"
        :data="item"
      />
    </template>
  </div>
</template>

<script>
export default {
  name: 'ViewItem',
  components: {
    ViewStep: () => import('./view-step')
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    len: {
      type: Number,
      default: 0
    },
    isSource: {
      type: Boolean,
      required: true
    },
    isShowBom: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfShowBom: true
    }
  },
  watch: {
    isShowBom(val) {
      this.selfShowBom = val
    }
  },
  methods: {
    groupToggle() {
      this.selfShowBom = !this.selfShowBom
    }
  }
}
</script>

<style lang="less" scoped>
.view-group {
  position: relative;
  font-family: 'Songti SC', 'NSimSun' !important;
  &:last-child {
    & > .view-box {
      .view-item {
        .view-toggle {
          .view-line-y {
            bottom: 50%;
          }
        }
      }
    }
  }
  .view-box {
    display: flex;
    & ~ .view-box {
      margin-top: 10px;
    }
    & ~ .view-group {
      padding-top: 10px;
      padding-left: 75px;
    }
    .view-item {
      display: flex;
      .view-toggle {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 40px;
        .toggle-icon {
          position: relative;
          color: @colorOrange;
          background: @colorWhite;
          z-index: 1;
          cursor: pointer;
        }
        .default-icon {
          position: relative;
          width: 14px;
          height: 14px;
          background: @colorWhite;
          border: 1px solid @colorGrayC;
          border-width: 1px;
          border-radius: 8px;
          z-index: 1;
        }
        .view-arrow {
          background: @colorWhite;
          color: @colorGrayC;
          width: 10px;
          font-size: 14px;
        }
        .view-line-x {
          border-top: @border;
          position: absolute;
          top: 50%;
          left: 5px;
          right: 5px;
          margin-top: -1px;
        }
        .view-line-y {
          border-left: @border;
          position: absolute;
          top: -10px;
          bottom: 0;
          left: 7px;
        }
      }
      .view-content {
        display: flex;
        min-height: 60px;
        padding: 10px;
        background: @colorGrayF;
        border: @border;
        border-radius: 5px;
        .view-info {
          width: 160px;
          display: flex;
          flex-direction: column;
          margin-left: 5px;
        }
      }
    }
  }
  .view-line-l {
    border-left: @border;
    position: absolute;
    bottom: 0;
    top: 0;
    left: 82px;
  }
}
</style>
